import { SimpleList } from 'components/List/SimpleList';

import { SimpleDocument } from '../SimpleDocument';

import styles from './styles.module.scss';
import { IDriverDocument } from '../../../../common/document/interfaces/driver-document';
import { useMemo } from 'react';

type InputProps = {
  documentList: IDriverDocument[];
  onAction: (document: IDriverDocument) => void;
};

export const SimpleDocumentList = ({ documentList, onAction }: InputProps) => {
  const documents = useMemo(
    () =>
      [...documentList].sort((x, z) =>
        z.documentType.localeCompare(x.documentType)
      ),
    [documentList]
  );
  return (
    <SimpleList
      className={styles.box}
      items={documents.map((document) => ({
        key: document.documentName,
        element: (
          <SimpleDocument
            noStatusIcon={document.isDefault}
            document={document}
            onClick={() => {
              onAction(document);
            }}
          />
        ),
      }))}
    />
  );
};
